<template>
  <div style="display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 42.432 42.43"
    >
      <g transform="translate(0 0)">
        <path
          :fill="iconColor"
          d="M-580.284-247.937c.854.34,1.023,1.036.91,1.909h.533c2.983,0,5.966.006,8.948,0a1.3,1.3,0,0,1,1.349.756,1.291,1.291,0,0,1-.367,1.5c-.785.833-1.553,1.681-2.339,2.534.8.809,1.581,1.6,2.367,2.393a1.236,1.236,0,0,1,.389,1.311,1.223,1.223,0,0,1-1.329.889q-3.231.006-6.463,0-1.305,0-2.61,0c-.135,0-.27.011-.432.019v4.435h.458q2.03,0,4.06,0a1.261,1.261,0,0,1,1.4,1.373q0,11.973,0,23.945a1.255,1.255,0,0,1-1.368,1.364q-17.172,0-34.344,0a1.24,1.24,0,0,1-1.349-1.376q-.007-3.625,0-7.25a1.257,1.257,0,0,1,1.391-1.383q4.764-.006,9.529,0h.533V-216q0-2.506,0-5.013a1.29,1.29,0,0,1,1.48-1.464q4.7,0,9.4,0h.564v-.493q0-3.853,0-7.706c0-1.05.464-1.512,1.515-1.512h4.212v-.531c0-4.543.008-9.087-.008-13.63a1.476,1.476,0,0,1,.985-1.585ZM-575.923-208v-21.675h-9.127V-208Zm-11.659-11.959H-596.5v11.941h8.922Zm-11.458,6.956h-8.921v4.99h8.921Zm26.5-30.512h-6.79v4.35h6.635c-.41-.4-.752-.713-1.08-1.046a1.242,1.242,0,0,1-.05-1.9C-573.418-242.567-573-243.01-572.537-243.518Z"
          transform="translate(610.863 247.937)"
        />
        <path
          :fill="iconColor"
          d="M-614-185.023a1.938,1.938,0,0,1,1.132-1,34.292,34.292,0,0,0,16.582-15.348c.066-.121.124-.246.181-.371.009-.02-.006-.052-.016-.123-.647.129-1.29.267-1.937.382a1.223,1.223,0,0,1-1.326-.7,1.229,1.229,0,0,1,.847-1.72q2.181-.485,4.372-.92a1.217,1.217,0,0,1,1.491.743q.984,1.96,1.95,3.928a1.255,1.255,0,0,1-.538,1.763,1.257,1.257,0,0,1-1.689-.667c-.275-.538-.541-1.08-.836-1.672-.091.148-.157.244-.212.346a36.8,36.8,0,0,1-17.868,16.641c-1.084.484-1.514.356-2.133-.615Z"
          transform="translate(614 209.636)"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";

export default {
  name: "ChallengesIcon",
  mixins: [globals],
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    color: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    iconColor() {
      const baseColor = this.color || this.isDescriptionColour || this.bgTheme || '#585957';
      const background = this.bgColor || this.shadowBgColor;

      if (this.isDarkTheme && background && this.areColorsSimilar(baseColor, background)) {
        return this.lightenColor(baseColor, 40);
      }
      return baseColor;
    }
  },
  methods: {
    hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b };
    },
    areColorsSimilar(color1, color2, threshold = 60) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);
      if (!rgb1 || !rgb2) return false;

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );
      return distance < threshold;
    },
    lightenColor(hex, percent) {
      const rgb = this.hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * (percent / 100)));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * (percent / 100)));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * (percent / 100)));

      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    }
  }
};
</script>
